<app-breadcrumb [links]="[{link: 'admin', name: 'Administração'}]" current="Destaques"></app-breadcrumb>
<div class="backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container mb-5">
      <div class="row pt-20 pb-10 d-flex justify-content-center">
        <div class="col-6">
          <h1 class="text-white text-shadow">Inserir Produtos a Destacar</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <button class="btn btn-secondary" *ngIf="model.id == 0" (click)="clear()">
            <h3>Novo Destaque</h3>
          </button>
        </div>
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
          <div class="row fixedHeight">
            <ng-container *ngFor="let item of list">
              <div class="row mb-2">
                <div class="">
                  <div class="row no-padd">
                    <div class="row">
                      <div class="card d-flex justify-content-center align-items-center model-border">
                        <div class="row col-12 no-padd">
                          <div class="col-12 d-flex justify-content-center backgroundColor white base" *ngIf="!item.typeMedia">
                            <img src="https://{{apiUrl}}/api/destaques/image/{{item.id}}/{{item.media.split(';')[0]}}" alt="..." class="img-fluid my-auto">
                          </div>
                          <div class="col-12 d-flex justify-content-center backgroundColor white base" style="height:190px;" *ngIf="item.typeMedia">
                            <!--img src="" alt="" class="fab fa-youtube img-fluid fa-5x textColor harvest-gold base"-->
                            <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
                              <path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path><path fill="#FFF" d="M20 31L20 17 32 24z"></path>
                              </svg>
                          </div>
                          <div class="card-body d-flex flex-wrap ">
                            <div class="col-12 d-flex mb-3 text-white">
                              <p class="my-auto mx-auto">{{item.nome}}</p>
                            </div>
                            <div class="col-12 d-flex mb-3 text-white">
                              <p class="my-auto mx-auto">{{item.subnome}}</p>
                            </div>
                            <div class="d-flex mx-auto">
                              <button class="btn red base" (click)="delete(item)"><fa-icon [icon]="faTrash" class="fad fa-trash"></fa-icon></button>
                            </div>
                            <div class="d-flex mx-auto">
                              <button class="btn green base" (click)="bind(item)"><fa-icon [icon]="faEdit" class="fad fa-edit"></fa-icon></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-6" *ngIf="model.id == 0"></div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-6 backgroundColor mine-shaft base p-4 text-white" *ngIf="model.id != 0">
          <div class="form-group">
            <label>Nome / Marca</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.nome">
          </div>
          <div class="form-group">
            <label>Modelo</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.subnome">
          </div>
          <div class="form-group">
            <label>Texto</label>&nbsp;
            <textarea class="form-control" rows="6" type="text" [(ngModel)]="model.body"></textarea>
          </div>
          <div class="form-group">
            <label>Link</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.link">
          </div>
          <div class="form-group d-flex">
            <label>Destaque Principal</label>&nbsp;
            <input class="form-control col-1" type="checkbox" style="height: 25px;" [(ngModel)]="model.master">
          </div>
          <div class="switch_box box_1">
            <label class="mt-2 mr-2 textColor harvest-gold base">Foto</label>&nbsp;
            <input type="checkbox" class="switch_1" [(ngModel)]="model.typeMedia">&nbsp;
            <label class="mt-2 ml-2 textColor harvest-gold base">Video</label>
          </div>
          <div class="form-group" *ngIf="model.typeMedia">
            <label>Link do Video</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.media2">
          </div>
          <app-imageInput titulo="" btn="Carregar Fotos" [(models)]="model.media1" [multiple]="true" *ngIf="!model.typeMedia"></app-imageInput>
          <button type="submit" class="btn btn-primary mr-5" (click)="send()">Submeter</button>
          <button type="submit" class="btn btn-secondary" (click)="clear()">Limpar</button>
        </div>
      </div>
    </div>
  </section>
</div>